module.exports = __webpack_public_path__ + "files/c969d3b44bb32212112b0717c87d6ed1.png";